





































import { Component, Mixins, Prop} from "vue-property-decorator";
import { Patient } from "../../../domain/patient";
import { PatientViewerMixin } from "./mixins";

@Component
export default class PatientViewer extends Mixins(PatientViewerMixin) {
  @Prop()
  patient: Patient;

  get sexIcon(): string {
    return "patient-viewer-sex-icon patient-viewer-sex-icon-" + this.sexKey.toLowerCase();
  }
}
